import { WorksheetMaterialUnit } from "generated/graphql";

export const MATERIAL_UNIT_OPTIONS = [
  { value: WorksheetMaterialUnit.TON, label: "Ton" },
  { value: WorksheetMaterialUnit.GALLON, label: "Gallon" },
  { value: WorksheetMaterialUnit.PAIL, label: "Pail" },
  { value: WorksheetMaterialUnit.BLOCK, label: "Block" },
  { value: WorksheetMaterialUnit.PALLET, label: "Pallet" },
  { value: WorksheetMaterialUnit.TRUCK, label: "Truck" },
  { value: WorksheetMaterialUnit.CUBIC_YARD, label: "Cubic Yd" },
  { value: WorksheetMaterialUnit.POUND, label: "Pound" },
  { value: WorksheetMaterialUnit.UNIT, label: "Unit" },
  { value: WorksheetMaterialUnit.EACH, label: "Each" },
];
